'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

function formatLabel(segment) {
  return segment.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

export default function Breadcrumbs() {
  const pathname = usePathname();

  if (!pathname || pathname === '/') return null;

  const segments = pathname.split('/').filter(Boolean);

  const breadcrumbs = segments.map((segment, index) => {
    return {
      label: formatLabel(segment),
      href: '/' + segments.slice(0, index + 1).join('/'),
    };
  });

  return (
    <nav className="2xl:text-lg lg:text-base md:text-sm text-xs text-[#626262] leading-[1.2em] tracking-[-0.02em]">
      <Link href="/" className="hover:underline font-normal">
        Home
      </Link>
      <span className="mx-0.5">/</span>

      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return isLast ? (
          <span key={crumb.href} className="font-normal">
            {crumb.label}
          </span>
        ) : (
          <React.Fragment key={crumb.href}>
            <span className="mx-0.5">/</span>
            <Link href={crumb.href} className="hover:underline font-normal">
              {crumb.label}
            </Link>
          </React.Fragment>
        );
      })}
    </nav>
  );
}
